import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { isCustomTransactionName } from '@wix/panorama-common-shared/utils';
import { defaults } from './utils/general-utils';
export class PanoramaTransactionImpl {
  constructor(baseClient, name, options) {
    this.baseClient = baseClient;
    this.name = name;
    this.options = options;
    if (!isCustomTransactionName(name)) {
      throw new Error(`"${name}" is an internal transaction and can't be used`);
    }
    this.baseClient = baseClient;
    bindPrototypeMethodsToSelf(this);
  }
  start(data, options) {
    return this.baseClient.reportTransactionStart(this.name, defaults(options, this.options), data);
  }
  finish(data, options) {
    return this.baseClient.reportTransactionFinish(this.name, defaults(options, this.options), data);
  }
}
//# sourceMappingURL=panorama-transaction.js.map